<!-- eslint-disable vuejs-accessibility/no-autofocus -->
<template>
  <cs-form-dialog
    v-model="popupDialog"
    :heading="pageTitle"
    :primary-action="primaryButtonActionItem"
    :secondary-action1="{ label: 'Cancel', eventName: 'dlg-cancel' }"
    @primary-click="primaryButtonActionItem.label === 'Create' ? createModule() : goToNextPage()"
    @secondary1-click="popupDialog = false"
  >
    <template v-slot:cs-form-dialog-content>
      <v-container style="height: 300px" fluid>
        <v-row v-if="!emptyModulePageDisplayed">
          <v-col md="6" sm="12">
            <cs-button
              left-icon="mdi-file-document-plus-outline"
              primary
              information
              title="Empty module"
              description="Start a new empty module to organise your content."
            ></cs-button>
          </v-col>
        </v-row>
        <v-form
          v-if="emptyModulePageDisplayed"
          id="create-dialog--empty-module-form"
          ref="emptyModuleForm"
          v-model="emptyModuleValid"
        >
          <v-row style="height: 100%" align="center" justify="center">
            <v-col md="2" cols="12">Module name</v-col>
            <v-col md="4" cols="12">
              <v-text-field
                id="create-dialog--module-name-txt"
                autofocus
                density="compact"
                v-model="moduleName"
                color="primary"
                class="mt-6"
                variant="outlined"
                :rules="nameRules"
                required
              ></v-text-field>
            </v-col>
            <v-col md="6" cols="12">
              <v-list-item style="height: 200px">
                <v-list-item-title>About Modules</v-list-item-title>
                <v-spacer></v-spacer>
                <v-list-item-subtitle class="text-wrap pt-4">
                  <!-- eslint-disable max-len -->
                  Start a new Module to create and organise your custom policy content.
                </v-list-item-subtitle>
              </v-list-item>
            </v-col>
          </v-row>
        </v-form>
      </v-container>
    </template>
  </cs-form-dialog>
</template>

<script>
import { CSBase, CSFormDialog } from '@complispace/cs-design-system';
import { content } from '@/api';
import dataEngine from '@/lib/engine';
import * as types from '@/store/mutationTypes';

const ITEM_TYPES = {
  EMPTY_MODULE: 1
  // EMPTY_PAGE: 2, // New item sample
};

export default {
  name: 'CreateDialog',

  components: {
    CSFormDialog
  },

  extends: CSBase,

  props: {
    showDialog: {
      type: Boolean,
      required: true,
      default: false
    }
  },

  data() {
    return {
      ITEM_TYPES,
      selectedItemType: ITEM_TYPES.EMPTY_MODULE,
      emptyModuleValid: false,
      popupDialog: false,
      showNewUpdateDialog: false,
      pageTitle: 'Create',
      emptyModulePageDisplayed: false,
      selectedModule: 0,
      moduleName: '',
      nameRules: [
        (v) => !!v || 'Module name is required',
        (v) => (v && v.length <= 255) || 'Module name must be less than 256 characters'
      ]
    };
  },

  computed: {
    primaryButtonActionItem() {
      const createButtonAction = {
        label: 'Create'
      };

      const nextButtonAction = {
        label: 'Next'
      };
      return this.emptyModulePageDisplayed ? createButtonAction : nextButtonAction;
    }
  },

  watch: {
    showDialog(value) {
      if (value) {
        this.popupDialog = true;
        this.clear();
      }
    },

    popupDialog(value) {
      if (!value) {
        this.$emit('closed');
      }
    }
  },

  methods: {
    goToNextPage() {
      if (this.selectedModule === 0) {
        this.pageTitle = 'Create a new module';
        this.emptyModulePageDisplayed = true;
      }
    },

    clear() {
      this.pageTitle = 'Create';
      this.emptyModulePageDisplayed = false;
      this.moduleName = '';
      this.selectedModule = 0;
    },

    runFormValidation() {
      this.$refs.emptyModuleForm.validate();
    },

    async createModule() {
      this.runFormValidation();
      if (!this.moduleName || this.moduleName.length > 255) {
        return;
      }
      try {
        this.setLoading(true);

        const params = {
          name: this.moduleName
        };

        const res = await content.createModule(params);

        // update modules
        this.$store.dispatch('activatedCEModules/getAll', res.data.id);
        this.$store.commit(types.DATA_SET_MODULE_STATE, dataEngine.MANAGER_STATE.STATE_UPDATING);
      } catch (err) {
        this.showErrorResponseAlert(err);
      } finally {
        this.setLoading(false);
        this.popupDialog = false;
      }
    }
  }
};
</script>

<style scoped>
.create-dialog button {
  text-transform: none;
}
</style>
